export enum DocumentContextNamesEnum {
  Proposal = 'proposals',
  ProposalCancellation = 'proposal_cancellations',
  Analysis = 'analysis',
}
